import { render } from "./LeagueShowcase.vue?vue&type=template&id=22164efe&scoped=true"
import script from "./LeagueShowcase.vue?vue&type=script&lang=js"
export * from "./LeagueShowcase.vue?vue&type=script&lang=js"

import "./LeagueShowcase.vue?vue&type=style&index=0&id=22164efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22164efe"]])

export default __exports__